/* Деньги дня для сводки ОО (DayWork) из GET /api/finance/salary?from=d&to=d.
   03.10: допработа ключуется ИСПОЛНИТЕЛЕМ + id работы. calculateSalary отдаёт ту же
   работу ещё и плательщику такси — строкой «Такси за …» с тем же id и earning 0.
   С ключом по одному id эта строка (результаты отсортированы по total) могла прийти
   позже и затереть настоящую сумму исполнителя → в сводке ₽0, и NumPad открывался с 0,
   хотя зарплата и расчётки верные. */

export interface SalaryDayResp {
  results?: {
    staffId: string;
    days?: Record<string, {
      extra_work?: { id: number; earning?: number }[];
      hall_admin?: { branch_id?: string; earning?: number; hours?: number; rate?: number } | null;
    }>;
  }[];
}

export interface DayPay {
  /** Ключ — ewPayKey(исполнитель, id работы). */
  ew: Map<string, number>;
  /** Ключ — `${staffId}_${branchId}`. */
  ha: Map<string, { earning: number; hours: number; rate: number }>;
}

export const ewPayKey = (operatorId: string | number, id: number): string => `${operatorId}_${id}`;

export function dayPayFromSalary(r: SalaryDayResp, d: string): DayPay {
  const ew = new Map<string, number>();
  const ha = new Map<string, { earning: number; hours: number; rate: number }>();
  for (const st of r.results ?? []) {
    const day = st.days?.[d];
    for (const e of day?.extra_work ?? []) ew.set(ewPayKey(st.staffId, e.id), Number(e.earning) || 0);
    if (day?.hall_admin) ha.set(`${st.staffId}_${day.hall_admin.branch_id ?? ""}`, {
      earning: Number(day.hall_admin.earning) || 0, hours: Number(day.hall_admin.hours) || 0, rate: Number(day.hall_admin.rate) || 0,
    });
  }
  return { ew, ha };
}
